import React, { useState } from "react";
import "./CuppingGuideWidget.css";

const CuppingGuideWidget = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [expandedCategory, setExpandedCategory] = useState(null);

  const categories = [
    {
      id: "dry_aroma",
      name: "Dry Aroma",
      shortDescription: "Fragrance of ground coffee before water",
      whatToNote: "Fragrance characteristics (fruity, floral, nutty, etc.)",
      example: '"Dry aroma score 4, notes of chocolate and hazelnut"',
    },
    {
      id: "wet_aroma",
      name: "Wet Aroma",
      shortDescription: "Aroma after adding hot water",
      whatToNote: "How the aroma changes with water",
      example: '"Wet aroma score 4, bright citrus notes emerging"',
    },
    {
      id: "flavor_hot",
      name: "Flavor (Hot)",
      shortDescription: "First impressions when tasting hot (~70°C)",
      whatToNote: "Initial flavor profile and intensity",
      example: '"Flavor hot score 4, bright berry notes with clean finish"',
    },
    {
      id: "flavor_cooling",
      name: "Flavor (Cooling)",
      shortDescription: "Flavor evolution as it cools (~60°C)",
      whatToNote: "Flavor development and changes",
      example:
        '"Flavor cooling score 4, sweetness increases, caramel develops"',
    },
    {
      id: "aftertaste",
      name: "Aftertaste",
      shortDescription: "Lingering taste after swallowing",
      whatToNote: "Length and quality of finish",
      example: '"Aftertaste score 4, long clean finish with chocolate notes"',
    },
    {
      id: "acidity",
      name: "Acidity",
      shortDescription: "Bright, lively quality (not sourness)",
      whatToNote: "Intensity and quality (citric, malic, etc.)",
      example: '"Acidity score 4, vibrant citrus acidity, well-integrated"',
    },
    {
      id: "sweetness",
      name: "Sweetness",
      shortDescription: "Natural sugars perceived in the cup",
      whatToNote: "Presence and quality of sweetness",
      example: '"Sweetness score 5, exceptional honey sweetness throughout"',
    },
    {
      id: "body",
      name: "Body",
      shortDescription: "Tactile feel or weight in the mouth",
      whatToNote: "Mouthfeel (light, medium, heavy, creamy, etc.)",
      example: '"Body score 3, medium body with smooth texture"',
    },
    {
      id: "balance",
      name: "Balance",
      shortDescription: "How well all elements work together",
      whatToNote: "Harmony between acidity, sweetness, body, and flavor",
      example: '"Balance score 4, all elements complement each other well"',
    },
    {
      id: "defects",
      name: "Defects",
      shortDescription: "Off-flavors or negative characteristics",
      whatToNote:
        "Type and intensity of defects (earthy, fermented, papery, etc.)",
      example: '"Defects score 2, slight paper taste detected"',
    },
    {
      id: "overall_impression",
      name: "Overall Impression",
      shortDescription: "Final assessment of the coffee",
      whatToNote: "Overall quality and drinkability",
      example:
        '"Overall impression score 4, excellent daily espresso candidate"',
    },
  ];

  const toggleCategory = (categoryId) => {
    setExpandedCategory(expandedCategory === categoryId ? null : categoryId);
  };

  return (
    <div className="cupping-guide-widget">
      <button
        className="guide-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <span className="guide-title">Cupping Guide</span>
        <span className="expand-icon">{isExpanded ? "−" : "+"}</span>
      </button>

      {isExpanded && (
        <div className="guide-content">
          <div className="scoring-scale">
            <h4>Scoring Scale</h4>
            <div className="scale-items">
              <span>5 = Exceptional</span>
              <span>4 = Good</span>
              <span>3 = Acceptable</span>
              <span>2 = Flawed</span>
              <span>1 = Unacceptable</span>
            </div>
          </div>

          <div className="categories-grid">
            {categories.map((category) => (
              <div key={category.id} className="category-item">
                <button
                  className="category-header"
                  onClick={() => toggleCategory(category.id)}
                >
                  <div className="category-info">
                    <h5>{category.name}</h5>
                    <p className="category-short">
                      {category.shortDescription}
                    </p>
                  </div>
                  <span className="category-expand">
                    {expandedCategory === category.id ? "−" : "+"}
                  </span>
                </button>

                {expandedCategory === category.id && (
                  <div className="category-details">
                    <div className="detail-section">
                      <strong>What to note:</strong>
                      <p>{category.whatToNote}</p>
                    </div>
                    <div className="detail-section">
                      <strong>Example:</strong>
                      <p className="example-text">{category.example}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CuppingGuideWidget;
